<template>
  <div class="no-deliver-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="title">
          不发货地区
          <div class="btn" @click="updateModal">编辑</div>
        </div>
        <div class="area">
          <span v-for="(item, index) in nameArr" :key="index">{{ item }}</span>
        </div>
      </div>
    </div>
    <el-dialog
      title="不发货地区"
      width="880px"
      :visible.sync="visible"
      :close-on-click-modal="false"
    >
      <div class="area-box">
        <div class="area-item" v-for="item in areaArr" :key="item.value">
          <el-popover width="600" trigger="click" placement="bottom-start">
            <div class="area-box county">
              <div
                class="area-item"
                v-for="city in item.children"
                :key="city.value"
              >
                <el-popover
                  width="600"
                  trigger="click"
                  placement="bottom-start"
                >
                  <div class="area-box city">
                    <div
                      class="area-item"
                      v-for="county in city.children"
                      :key="county.value"
                    >
                      <div class="province">
                        <el-checkbox
                          v-model="county.checked"
                          @change="
                            (val) =>
                              changeArea(val, 'county', item, city, county)
                          "
                          class="checkbox"
                        ></el-checkbox>
                        {{ county.label }}
                      </div>
                    </div>
                  </div>
                  <div slot="reference" class="province">
                    <el-checkbox
                      :indeterminate="city.indeterminate"
                      v-model="city.checked"
                      @change="(val) => changeArea(val, 'city', item, city)"
                      class="checkbox"
                    ></el-checkbox>
                    {{ city.label }}
                    <i class="el-icon-caret-bottom" v-if="city.children"></i>
                  </div>
                </el-popover>
              </div>
            </div>
            <div slot="reference" class="province">
              <el-checkbox
                :indeterminate="item.indeterminate"
                v-model="item.checked"
                @change="(val) => changeArea(val, 'province', item)"
                class="checkbox"
              ></el-checkbox>
              {{ item.label }}
              <i class="el-icon-caret-bottom"></i>
            </div>
          </el-popover>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="visible = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="handleConfirm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'no-deliver',
  data() {
    return {
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '不发货地区'
      },
      loading: 0,
      visible: false,
      cityVisible: false,
      nameArr: [],
      areaArr: [],
      areaObj: {},
      id: null,
      areaId: null
    };
  },
  async mounted() {
    // let query = this.$route.query;
    // this.id = +query.id;
    // this.id && await this.getInfo();
    this.getInfo();
    // this.getArea();
  },
  computed: {},
  methods: {
    // // 获取分享详情
    getInfo() {
      this.loading++;
      return this.httpGet(this.$root.getNoDeliver).then(
        (res) => {
          this.loading--;
          this.nameArr = res.name;
          this.areaId = res.info.id;
          let list = res.info.notDeliver;
          let obj = {};
          list.forEach((item) => {
            obj[item] = true;
          });
          this.areaObj = obj;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    async updateModal() {
      await this.getInfo();
      await this.getArea();
      this.visible = true;
    },
    // // 保存修改
    // handleShare() {
    //   this.loading++;
    //   this.httpPost(this.$root.updateShare, this.configure).then(
    //     (res) => {
    //       this.loading--;
    //       this.$message({
    //         message: '操作成功',
    //         type: 'success'
    //       });
    //       this.getShareInfo();
    //     },
    //     (res) => {
    //       this.loading--;
    //       this.$message.error(res);
    //     }
    //   );
    // },
    changeArea(val, type, province, city, county) {
      // console.log(val);
      // console.log(this.areaArr);
      let filterArr = [];
      let length = 0;
      let flag = false;
      switch (type) {
        case 'province':
          province.indeterminate = false;
          province.children = province.children.map((item) => {
            item.children.forEach((item2) => {
              item2.checked = val;
            });
            return { ...item, checked: val };
          });
          break;
        case 'city':
          city.indeterminate = false;
          city.children = city.children.map((item) => {
            return { ...item, checked: val };
          });
          flag = false;
          filterArr = province.children.filter((item) => {
            if (item.indeterminate) flag = true;
            return item.checked;
          });
          length = filterArr.length;
          province.indeterminate = Boolean(
            length && length !== province.children.length
          );
          if (flag) province.indeterminate = true;
          province.checked = length === province.children.length;
          break;
        case 'county':
          flag = false;
          filterArr = city.children.filter((item) => {
            if (item.indeterminate) flag = true;
            return item.checked;
          });
          length = filterArr.length;
          city.indeterminate = Boolean(
            length && length !== city.children.length
          );
          if (flag) city.indeterminate = true;
          city.checked = length === city.children.length;

          flag = false;
          filterArr = [];
          length = 0;
          filterArr = province.children.filter((item) => {
            if (item.indeterminate) flag = true;
            return item.checked;
          });
          length = filterArr.length;
          province.indeterminate = Boolean(
            length && length !== province.children.length
          );
          if (flag) province.indeterminate = true;
          province.checked = length === province.children.length;
          break;
        default:
          break;
      }
      // console.log(this.areaArr);

      // this.areaArr = [...this.areaArr];
    },
    handleConfirm() {
      console.log(this.areaArr);
      let arr = [];
      for (let i = 0; i < this.areaArr.length; i++) {
        let province = this.areaArr[i];
        if (province.checked) {
          arr.push(province.value);
          continue;
        }
        for (let j = 0; j < province.children.length; j++) {
          let city = province.children[j];
          if (city.checked) {
            arr.push(city.value);
            continue;
          }
          let children = city.children || [];
          for (let k = 0; k < children.length; k++) {
            let county = children[k];
            if (county.checked) {
              arr.push(county.value);
            }
          }
        }
      }
      this.loading++;
      this.httpPut(this.$root.setNoDeliver, {
        notDeliver: arr
        // id: this.areaId
      }).then(
        async (res) => {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.visible = false;
          this.loading--;
          await this.getInfo();
          // this.getArea();
        },
        (res) => {
          this.loading--;
        }
      );
    },
    getArea() {
      this.loading++;
      this.httpGet(this.$root.getArea).then(
        (res) => {
          this.loading--;
          // 根据市 划分区
          let countyObj = {};
          for (let countyId in res.county_list) {
            let cId = (countyId + '').substring(0, 4);
            if (countyObj[cId]) {
              countyObj[cId].push({
                label: res.county_list[countyId],
                value: +countyId,
                checked: this.areaObj[+countyId] || false,
                indeterminate: false
              });
            } else {
              countyObj[cId] = [
                {
                  label: res.county_list[countyId],
                  value: +countyId,
                  checked: this.areaObj[+countyId] || false,
                  indeterminate: false
                }
              ];
            }
          }
          // 根据省 划分市
          let areaArr = [];
          let cityObj = {};
          // let cityEmptyObj = {};
          for (let cityId in res.city_list) {
            let pId = (cityId + '').substring(0, 2);
            if (cityObj[pId]) {
              cityObj[pId].push({
                label: res.city_list[cityId],
                value: +cityId,
                children: countyObj[(cityId + '').substring(0, 4)],
                checked: this.areaObj[+cityId] || false,
                indeterminate: false
              });
            } else {
              cityObj[pId] = [
                {
                  label: res.city_list[cityId],
                  value: +cityId,
                  children: countyObj[(cityId + '').substring(0, 4)],
                  checked: this.areaObj[+cityId] || false,
                  indeterminate: false
                }
              ];
            }
          }
          for (let provinceId in res.province_list) {
            areaArr.push({
              value: +provinceId,
              label: res.province_list[provinceId],
              children: cityObj[(provinceId + '').substring(0, 2)],
              checked: this.areaObj[+provinceId] || false,
              indeterminate: false
            });
          }
          console.log(areaArr);

          areaArr.forEach((province) => {
            let provinceChecked = province.checked;
            province.children.forEach((city) => {
              if (provinceChecked) city.checked = true;
              let cityChecked = city.checked;
              let children = city.children || [];
              children.forEach((county) => {
                if (cityChecked) county.checked = true;
              });
            });
          });

          areaArr.forEach((province) => {
            province.children.forEach((city) => {
              let children = city.children || [];
              let num = children.filter((county) => {
                return county.checked;
              }).length;
              city.indeterminate = Boolean(num && num !== children.length);
              city.checked = num === children.length;
            });
          });

          areaArr.forEach((province) => {
            let indeterminate = false;
            let checked = true;
            province.children.forEach((city) => {
              if (city.indeterminate || city.checked) indeterminate = true;
              if (!city.checked) checked = false;
            });
            if (checked) indeterminate = false;
            province.indeterminate = indeterminate;
            province.checked = checked;
          });

          this.areaArr = areaArr;
        },
        (err) => {
          this.$message.error(err);
          this.loading--;
        }
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.no-deliver-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px;
      border-radius: 2px;

      .title {
        word(14px, #404157);
        font-weight: 550;
        flex-x(flex-start);

        .btn {
          confirm-btn();
          width: 75px;
          height: 32px;
          line-height: 32px;
          box-sizing: border-box;
          font-weight: normal;
          margin-left: 24px;
        }
      }

      .area {
        border: 1px solid #F0F0F0;
        line-height: 45px;
        padding: 0 20px;
        border-radius: 5px;
        margin-top: 20px;
        word(14px, #E6456A);

        span {
          margin-right: 20px;
        }
      }
    }
  }
}

.area-box {
  flex-x(flex-start);
  flex-wrap: wrap !important;

  .area-item {
    width: 168px;
    line-height: 40px;
    word(14px, #333);
    flex-x(flex-start);

    .province {
      width: 100%;
      flex-x(flex-start);
      overflow: hidden;
      flex-wrap: nowrap;
      white-space: nowrap;

      .checkbox {
        margin-right: 12px;
        // align-self: flex-start;
      }
    }
  }
}

.city, .county {
  .area-item {
    width: (1 / 3) * 100%;
  }
}
</style>
